module.exports = __webpack_public_path__ + "img/user-large-slash.6902f34a.svg";